import { TASK_STATE_CONFIG } from '../lib/constants';
import { T } from '../lib/design-tokens';

const DEFAULT_CFG = { label: 'Starting', color: T.cream35, bg: T.cream04 };

interface StateBadgeProps {
  state: string;
  size?: 'sm' | 'lg';
}

export function StateBadge({ state, size = 'sm' }: StateBadgeProps) {
  const cfg = TASK_STATE_CONFIG[state] ?? DEFAULT_CFG;
  const isLive = state === 'EXECUTING';

  return (
    <span
      className="inline-flex items-center gap-[5px] font-semibold"
      style={{
        padding: size === 'lg' ? '5px 14px' : '3px 10px',
        borderRadius: 100,
        fontSize: size === 'lg' ? 12 : 11,
        color: cfg.color,
        background: cfg.bg,
        fontFamily: T.mono,
        letterSpacing: '0.03em',
        textTransform: 'uppercase',
      }}
    >
      {isLive && (
        <span
          className="rounded-full shrink-0"
          style={{
            width: 5,
            height: 5,
            background: cfg.color,
            animation: 'pulse 1.5s ease-in-out infinite',
          }}
        />
      )}
      {cfg.label}
    </span>
  );
}
